// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerButtom_wrapper__B5NH4","content":"BannerButtom_content__f8pmv"};